module.exports = __webpack_public_path__ + "static/img/banner6.252a386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner6.jpg
// module id = Peoa
// module chunks = 1